const canvasWidth = 1754;
const canvasHeight = 1240;

const logoWidth = 300;
const logoHeight = 180;

const signatureWidth = 300;
const signatureHeight = 100;

function getPositions({
    elementWidth = 0,
    elementHeight = 0,
    extraY = 0,
    extraX = 0,
    margin = 32,
} = {}) {
    return {
        rightBottom: {
            x: canvasWidth - elementWidth - margin + extraX,
            y: canvasHeight - elementHeight - margin + extraY,
        },
        middleBottom: {
            x: (canvasWidth / 2) - (elementWidth / 2) + extraX,
            y: canvasHeight - elementHeight - margin + extraY,
        },
        middleTop: {
            x: (canvasWidth / 2) - (elementWidth / 2) + extraX,
            y: margin + extraY,
        },
        center: {
            x: (canvasWidth / 2) - (elementWidth / 2) + extraX,
            y: canvasHeight / 2 - elementHeight / 2 + extraY,
        },
    };
}

const certificateTemplates = [
    {
        type: 1,
        name: 'Azul e Amarelo',
        background: require('@/assets/certificates/blue.png'),
        image: require('@/assets/certificates/blue-complete.png'),
        logoPosition: getPositions({
            elementWidth: logoWidth,
            elementHeight: logoHeight,
        }).rightBottom,
        studentNamePosition: getPositions({
            extraY: 60,
        }).center,
        workLoadPosition: getPositions({
            extraY: 180,
        }).center,
        conclusionDatePosition: getPositions({
            extraY: 300,
        }).center,
        signaturePosition: getPositions({
            elementWidth: signatureWidth,
            elementHeight: signatureHeight,
        }).middleBottom,
        fontStudentName: {
            size: 92,
            color: '#21325A',
            family: 'Amoresa',
        },
        fontWorkLoad: {
            size: 36,
            color: '#21325A',
            family: 'Unna',
        },
        fontConclusionDate: {
            size: 36,
            color: '#21325A',
            family: 'Unna',
        },
        fontSignature: {
            size: 28,
            color: '#21325A',
            family: 'Unna',
        },
    },
    {
        type: 2,
        name: 'Marrom',
        background: require('@/assets/certificates/brown.png'),
        image: require('@/assets/certificates/brown-complete.png'),
        logoPosition: getPositions({
            elementWidth: logoWidth,
            elementHeight: logoHeight,
            extraY: 40,
        }).middleTop,
        studentNamePosition: getPositions({
            extraY: 60,
        }).center,
        workLoadPosition: getPositions({
            extraY: 180,
        }).center,
        conclusionDatePosition: getPositions({
            extraY: 300,
        }).center,
        signaturePosition: getPositions({
            elementWidth: signatureWidth,
            elementHeight: signatureHeight,
            extraY: -80,
        }).middleBottom,
        fontStudentName: {
            size: 64,
            color: '#3D3B3A',
            family: 'Crimson Pro',
            weight: 'bold',
        },
        fontWorkLoad: {
            size: 32,
            color: '#3D3B3A',
            family: 'Open Sans',
            weight: 'normal',
        },
        fontConclusionDate: {
            size: 32,
            color: '#3D3B3A',
            family: 'Open Sans',
            weight: 'normal',
        },
        fontSignature: {
            size: 28,
            color: '#3D3B3A',
            family: 'Open Sans',
            weight: 'normal',
        },
    },
    {
        type: 3,
        name: 'Verde e laranja',
        background: require('@/assets/certificates/orange-and-green.png'),
        image: require('@/assets/certificates/orange-and-green-complete.png'),
        logoPosition: getPositions({
            elementWidth: logoWidth,
            elementHeight: logoHeight,
            extraY: 90,
        }).middleTop,
        studentNamePosition: getPositions({
            extraY: 80,
        }).center,
        workLoadPosition: getPositions({
            extraY: 180,
        }).center,
        conclusionDatePosition: getPositions({
            extraY: 300,
        }).center,
        signaturePosition: getPositions({
            elementWidth: signatureWidth,
            elementHeight: signatureHeight,
            extraY: -80,
        }).middleBottom,
        fontStudentName: {
            size: 80,
            color: '#1D3644',
            family: 'Open Sans',
            weight: '800',
        },
        fontWorkLoad: {
            size: 40,
            color: '#1D3644',
            family: 'Open Sans',
            weight: 'normal',
        },
        fontConclusionDate: {
            size: 40,
            color: '#1D3644',
            family: 'Open Sans',
            weight: 'normal',
        },
        fontSignature: {
            size: 28,
            color: '#1D3644',
            family: 'Open Sans',
            weight: 'normal',
        },
    },
    {
        type: 4,
        name: 'Laranja e Azul',
        background: require('@/assets/certificates/blue-and-orange.png'),
        image: require('@/assets/certificates/blue-and-orange-complete.png'),
        logoPosition: getPositions({
            elementWidth: logoWidth,
            elementHeight: logoHeight,
            extraY: 180,
        }).middleTop,
        studentNamePosition: getPositions({
            extraY: 192,
        }).center,
        workLoadPosition: getPositions({
            extraY: 252,
        }).center,
        conclusionDatePosition: getPositions({
            extraY: 372,
        }).center,
        signaturePosition: getPositions({
            elementWidth: signatureWidth,
            elementHeight: signatureHeight,
        }).middleBottom,
        fontStudentName: {
            size: 72,
            color: '#DE5602',
            family: 'Playfair Display',
            weight: '800',
        },
        fontWorkLoad: {
            size: 32,
            color: '#0F1F66',
            family: 'Open Sans',
            weight: 'normal',
        },
        fontConclusionDate: {
            size: 32,
            color: '#0F1F66',
            family: 'Open Sans',
            weight: 'normal',
        },
        fontSignature: {
            size: 28,
            color: '#0F1F66',
            family: 'Open Sans',
            weight: 'normal',
        },
    },
    {
        type: 5,
        name: 'Dourado e Preto',
        background: require('@/assets/certificates/gold-and-black.png'),
        image: require('@/assets/certificates/gold-and-black-complete.png'),
        logoPosition: getPositions({
            elementWidth: logoWidth,
            elementHeight: logoHeight,
        }).rightBottom,
        studentNamePosition: getPositions({
            extraX: 200,
        }).center,
        workLoadPosition: getPositions({
            extraX: 200,
            extraY: 140,
        }).center,
        conclusionDatePosition: getPositions({
            extraX: 200,
            extraY: 260,
        }).center,
        signaturePosition: getPositions({
            elementWidth: signatureWidth,
            elementHeight: signatureHeight,
        }).middleBottom,
        fontStudentName: {
            size: 104,
            color: '#000000',
            family: 'Alex Brush',
        },
        fontWorkLoad: {
            size: 36,
            color: '#000000',
            family: 'Garet',
        },
        fontConclusionDate: {
            size: 36,
            color: '#000000',
            family: 'Garet',
        },
        fontSignature: {
            size: 28,
            color: '#000000',
            family: 'Garet',
        },
    },
];

export {
    certificateTemplates,
    canvasWidth,
    canvasHeight,
    logoWidth,
    logoHeight,
    signatureWidth,
    signatureHeight,
};
